export default {
  userGeoIP: [],
};
